var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: { title: "媒体库", visible: _vm.drawer },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "media" },
        _vm._l(_vm.picList, function (item, key) {
          return _c(
            "el-image",
            {
              key: key,
              staticClass: "header-img-box-list",
              attrs: {
                src:
                  item.url && item.url.slice(0, 4) !== "http"
                    ? _vm.path + item.url
                    : item.url,
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.chooseImg(item.url, _vm.target, _vm.targetKey)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "header-img-box-list",
                  attrs: { slot: "error" },
                  slot: "error",
                },
                [_c("i", { staticClass: "el-icon-picture-outline" })]
              ),
            ]
          )
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }